import { Injectable } from '@angular/core'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { switchMap, tap } from 'rxjs/operators'
import { Observable, Subject } from 'rxjs'
import { UserStore } from './user.store'
import type { Profile, Settings, UpdateProfile, UpdateSettings } from './user.model'

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(
    private userStore: UserStore,
    private http: HttpClient,
  ) {}

  // Changed Subject<void> from <never> as required by RxJS update to 7
  private settingsChangedSubject = new Subject<void>()

  settingsChanged$ = this.settingsChangedSubject.asObservable()

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>('./Api/profile/profile').pipe(tap(profile => this.userStore.update({ profile })))
  }

  saveProfile(data: UpdateProfile): Observable<HttpResponse<null>> {
    return this.http.post<HttpResponse<null>>('./Api/profile/profile', data).pipe(
      tap(() =>
        this.userStore.update(oldState => {
          return { profile: { ...oldState.profile, FirstName: data.FirstName, LastName: data.LastName, Company: data.Company } }
        }),
      ),
    )
  }

  getSettings(): Observable<Settings> {
    return this.http.get<Settings>('./Api/profile/settings').pipe(tap(settings => this.userStore.update({ settings })))
  }

  saveSettings(data: UpdateSettings): Observable<Settings> {
    return this.http.post<HttpResponse<null>>('./Api/profile/settings', data).pipe(
      switchMap(() => {
        return this.getSettings()
      }),
      tap(() => this.settingsChangedSubject.next()),
    )
  }
}
